// LeaveManagement.js
import React from "react";
import "./LeaveManagement.css";

const LMSPage = () => {
    return (
      <div className="container">
        <header className="header">
          <h1>Welcome to Our Learning Management System</h1>
          {/* <p>Your journey to learning starts here</p> */}
        </header>
        
        <section className="features">
          <h2>Key Features</h2>
          <div className="feature-cards">
            <div className="card">
              <h3>Interactive Courses</h3>
              <p>Engage with multimedia content and hands-on activities.</p>
            </div>
            <div className="card">
              <h3>Real-time Feedback</h3>
              <p>Receive instant feedback on your progress.</p>
            </div>
            <div className="card">
              <h3>Track Progress</h3>
              <p>Monitor your learning milestones and achievements.</p>
            </div>
          </div>
        </section>
  
        <section className="call-to-action">
          <h2>Start Your Learning Journey</h2>
          {/* <p>Sign up today to access a variety of courses.</p> */}
          <button className="cta-button">Join Now</button>
        </section>
  
        {/* <footer className="footer">
          <p>&copy; 2025 LMS Platform. All rights reserved.</p>
        </footer> */}
      </div>
    );
  };
  
  export default LMSPage;